export enum UserRole {
  SuperAdmin = 'S',
  Admin = 'A',
  MedicalOperator = 'MO',
  DemoAccount = 'DEMO',
}

export const userRoleLabelMap = new Map<UserRole, string>([
  [UserRole.SuperAdmin, 'user.role.superAdmin'],
  [UserRole.Admin, 'user.role.admin'],
  [UserRole.MedicalOperator, 'user.role.medicalOperator'],
  [UserRole.DemoAccount, 'user.role.demoAccount'],
]);

export enum TokenAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  NeedPasswordChange = 'NEED_PASSWORD_CHANGE',
  UserPasswordChange = 'USER_PASSWORD_CHANGE',
  NeedMfaVerification = 'NEED_MFA_VERIFICATION',
  NeedMfaEnabled = 'NEED_MFA_ENABLED',
  WaitingForActivation = 'WAITING_FOR_ACTIVATION',
  Archived = 'ARCHIVED',
}

export interface TokenPayload {
  accountStatus: TokenAccountStatus;
  iss: string;
  userCreateDate: string;
  partnerId?: number;
  role: UserRole;
  type: string;
  exp: number;
  iat: number;
}
